import React, { Fragment } from 'react'
import styled, { keyframes } from 'styled-components'
import { TweenMax, Strong } from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

import arrow from '../img/arrow.svg'
import { introGutter, media } from '../utils/style-utils'

const UpDown = keyframes`
  0%, 100% {
    transform: translateY(-5px);
  }
  50% {
    transform: translateY(5px);
  }
`

const ScrollButton = styled.button`
  appearance: none;
  border: 0;
  background: none;
  font-size: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  cursor: pointer;

  position: absolute;
  bottom: calc(${introGutter} / 2 - 25px);
  left: 50%;
  transform: translatex(-50%);

  &:focus {
    outline: none;
  }
`

const ScrollIcon = styled.span`
  animation: ${UpDown} 1400ms infinite ease-in-out;
  background-image: url(${arrow});
  background-repeat: no-repeat;
  background-position: center;
  width: inherit;
  height: inherit;
  display: block;
`

const ScrollLabel = styled.button`
  border: 0;
  border-radius: 0;
  padding: 0;
  background: none;
  white-space: nowrap;
  font-family: inherit;
  cursor: pointer;

  transform-origin: left center;
  transform: rotate(-90deg);
  font-size: 10px;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  font-weight: bold;
  position: absolute;
  line-height: 2em;
  left: calc(${introGutter} / 2);
  bottom: ${introGutter};
  display: none;
  &:focus {
    outline: none;
  }
  ${media.desktop`
    display: block;
  `};
`

const ScrollIndicator = props => {
  const { button, className, target, label } = props
  const scrollDown = () => {
    const scrollOffset = target ? target : window.innerHeight
    TweenMax.to(window, 1, {
      scrollTo: scrollOffset,
      ease: Strong.easeInOut,
    })
  }

  if (button) {
    return (
      <ScrollButton className={className} onClick={scrollDown}>
        <ScrollIcon>{label}</ScrollIcon>
      </ScrollButton>
    )
  } else {
    return (
      <ScrollLabel className={className} onClick={scrollDown}>
        {label}
      </ScrollLabel>
    )
  }
}

export default ScrollIndicator



// WEBPACK FOOTER //
// ./src/components/ScrollIndicator.js